import React, { Fragment, useState, useEffect } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import DatePicker from "react-datepicker";
import records from '../../../Services/records'
import { toast, Slide } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faCog, faEnvelope, faPhone, faBars, faTags } from "@fortawesome/free-solid-svg-icons";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import {
    Input,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    InputGroup,
} from "reactstrap";
export default function ActivityLog({ tabKey, uatId, list, tasks }) {

    const [data, setData] = useState({ report_type: "weekly", uat_id: uatId })
    const [activities, setActivities] = useState([])
    const [d1, setD1] = useState()
    const [d2, setD2] = useState()
    const [isLoading, setIsLoading] = useState(false)

    const repeat = 6
    const handleChange = (v, k) => { setData({ ...data, [k]: v }); }


    useEffect(() => {
        if (uatId !== undefined) {
            records.getActivities(data).then((res) => {
                setActivities(res.data)
                setIsLoading(false)
                data.start_date = undefined
                data.end_date = undefined
                setD1()
                setD2()

            }).catch((err) => {
                console.log("error is", err)
            }).finally(() => setIsLoading(false))
        }
    }, [uatId])

    useEffect(() => {
        let isMounted = true;
        if (uatId !== undefined) {
            setIsLoading(true)
            if (tabKey === "3" && (data.report_type === "weekly" || data.report_type === "monthly")) {

                records.getActivities(data).then((res) => {
                    if (isMounted) {
                        setActivities(res.data)
                        setIsLoading(false)
                        data.start_date = undefined
                        data.end_date = undefined
                        setD1()
                        setD2()
                    }

                }).catch((err) => {
                    console.log("error is", err)
                }).finally(() => setIsLoading(false))


            }
            return () => { isMounted = false };
        }

    }, [list, data, tasks])


    const customLogs = () => {
        setActivities([])
        if (data.start_date !== undefined && data.end_date !== undefined) {

            records.getActivities(data).then((res) => {
                setActivities(res.data)
                setIsLoading(false)

            })
        }
        else {
            notify22("Please enter starting and ending date")
        }

    }

    const notify22 = (msg) =>
        toast(msg, {
            transition: Slide,
            autoClose: 5000,
            position: "top-right",
            type: "warning",

        });
    const dateFormatting = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');

    }

    return (
        <Fragment>
            <TransitionGroup>
                <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                    timeout={0} enter={false} exit={false}>
                    <div>
                        <Row>
                            <Col md="12">
                                <Row className="mb-0 ">
                                    <Col md="12">
                                        <Card className="main-card mb-1">
                                            <CardBody>
                                                <CardTitle></CardTitle>
                                                <Row className="g-1">
                                                    <Col md="4" >
                                                        <Input disabled={uatId === undefined} type="select" name="select" id="exampleSelect" className="mt-1 text-uppercase"
                                                            value={data.report_type || " "} onChange={(e) => { handleChange(e.target.value, "report_type"); setIsLoading(true) }} >
                                                            <option>weekly</option>
                                                            <option>monthly</option>
                                                            <option>custom</option>


                                                        </Input>
                                                    </Col>

                                                    <Col md="8" className="mt-2 ">
                                                        {data.report_type === "custom" && (
                                                            <Row className="g-1">
                                                                <Col md="8">
                                                                    <InputGroup>
                                                                        <DatePicker placeholderText="From" className="form-control" selected={d1}
                                                                            onChange={(e) => { handleChange(dateFormatting(e), "start_date"); setD1(e) }}
                                                                        />
                                                                        <DatePicker placeholderText="To" className="form-control" selected={d2}
                                                                            onChange={(e) => { handleChange(dateFormatting(e), "end_date"); setD2(e) }}
                                                                        />
                                                                    </InputGroup>
                                                                </Col>
                                                                <Col md="4">
                                                                    <Button block outline className="mb-2 btn-transition" color="primary" onClick={customLogs}>
                                                                        Search
                                                                    </Button>
                                                                </Col>

                                                            </Row>
                                                        )}

                                                    </Col>


                                                </Row>

                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row className="mt-0">
                                    <Col md="12">
                                        <Card className="main-card mb-3">
                                            <CardBody>

                                                <CardTitle></CardTitle>
                                                {isLoading ? (

                                                    <SkeletonTheme highlightColor="#E0E0E0">

                                                        {
                                                            [...Array(repeat)].map((e, k) => {
                                                                return (
                                                                    <Row key={k} className="mb-3" >
                                                                        <Col xs="1">

                                                                        </Col>
                                                                        <Col xs="2" className="mt-1">
                                                                            <Skeleton circle width={40} height={40} />
                                                                        </Col>
                                                                        <Col xs="9">
                                                                            <Skeleton height={15} width={200} />
                                                                            <Skeleton height={20} width={300} />
                                                                        </Col>
                                                                    </Row>
                                                                )
                                                            }


                                                            )

                                                        }


                                                    </SkeletonTheme>

                                                ) : (
                                                    <div className="scroll-area-lg">
                                                        <PerfectScrollbar>
                                                            <VerticalTimeline layout="1-column" className="vertical-time-icons ms-5" >

                                                                {activities.length > 0 ?

                                                                    (activities?.map((v, k) => {
                                                                        return (
                                                                            <VerticalTimelineElement className="vertical-timeline-item mb-4"
                                                                                key={k}
                                                                                date={v.datetime.slice(0, 10)}
                                                                                // icon={<i
                                                                                //     className="badge badge-dot badge-dot-xl ms-1 mt-2" style={{'backgroundColor': v.status === 'Success' || v.status === 'Completed' ? '#006633' : v.status === 'Failed' ? '#A00000 ' : '#FFD700'}}> </i>}
                                                                                icon={
                                                                                    <div className="timeline-icon border-white mt-4 ms-3" style={{ 'backgroundColor': v?.title.includes("Added") ? 'green' : v?.title.includes("Deleted") ? '#C00000' : '#FFBF00' }}>
                                                                                        {v.product_type === "Phone" && (
                                                                                            <FontAwesomeIcon icon={faPhone} className="text-white" />
                                                                                        )}
                                                                                        {v.product_type === "Email" && (
                                                                                            <FontAwesomeIcon icon={faEnvelope} className="text-white" />
                                                                                        )}
                                                                                        {v.product_type === "Notes" && (
                                                                                            <FontAwesomeIcon icon={faBook} className="text-white" />
                                                                                        )}
                                                                                        {v.product_type === "Crm" && (
                                                                                            <FontAwesomeIcon icon={faCog} className="text-white" />
                                                                                        )}
                                                                                        {v.product_type === "Task" && (
                                                                                            <FontAwesomeIcon icon={faBars} className="text-white" />
                                                                                        )}
                                                                                        {v.product_type === "Tag" && (
                                                                                            <FontAwesomeIcon icon={faTags} className="text-white" />
                                                                                        )}


                                                                                    </div>
                                                                                }
                                                                            >
                                                                                <h3 className="timeline-title ms-2" style={{ 'color': v?.title.includes("Added") ? 'green' : v?.title.includes("Deleted") ? '#C00000' : '#FFBF00' }}>{v.title}</h3>
                                                                                <h6 className="ms-2">
                                                                                    {v.description} on  <span className="fw-bold">{v.datetime.slice(11, 16)} </span>
                                                                                </h6>
                                                                            </VerticalTimelineElement>
                                                                        )

                                                                    })) : (
                                                                        <h3 className="text-center">No Logs Found</h3>

                                                                    )

                                                                }

                                                            </VerticalTimeline>
                                                        </PerfectScrollbar>
                                                    </div>
                                                )}
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>

                            </Col>

                        </Row>
                    </div>
                </CSSTransition>
            </TransitionGroup>
        </Fragment>
    )



}